// removed by extract-text-webpack-plugin
module.exports = {"medium":"src-components-modules-Card-style----size-module---medium---1pQxH paddingTop-m paddingBottom-m paddingLeftRight-m","large":"src-components-modules-Card-style----size-module---large---lHQCp paddingTop-l paddingBottom-l paddingLeftRight-l","mediumLarge":"src-components-modules-Card-style----size-module---mediumLarge---dZvtG paddingBottom-s paddingLeftRight-m breakPointS-display-flex breakPointS-justifyContent-center breakPointS-alignItems-center breakPointM-display-block"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Card/style/size.module.css
// module id = 1436
// module chunks = 168707334958949